<template>
    <v-dialog
            :value="!!value"
            :retain-focus="false"
            persistent
            max-width="800"
    >
        <v-form
                v-model="validForm"
                ref="form"
                @submit.prevent="submit"
        >
            <v-card
                    :loading="loading > 0"
                    :disabled="loading > 0"
            >
                <v-card-title class="grs-card-title px-0">
                    <span> {{ $t('user_form_title') }} </span>

                    <v-spacer></v-spacer>

                    <v-btn
                            text
                            small
                            icon
                            @click="$emit('close')"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pb-0">
                    <v-text-field
                            v-model="value.number"
                            :label="$t('fax_number')"
                            :rules="[rules.required]"
                            class="ltr"
                    ></v-text-field>
                    <v-text-field
                            v-model="value.vertical_service_code"
                            :label="$t('vertical_service_code')"
                            class="ltr"
                    ></v-text-field>
                    <v-text-field
                            class="ltr"
                            v-model="value.setup_fee"
                            :value="value.setup_fee ? $n(value.setup_fee) : null"
                            suffix="ریال "
                            @input="value.setup_fee = parseInt($event)"
                            :hint="priceToTomanPhrase(value.setup_fee)"
                            :label="$t('setup_fee')"
                            :rules="[rules.required]"
                    ></v-text-field>
                    <v-select
                            v-model="value.grade"
                            :label="$t('grade')"
                            :items="gradeOptions"
                            :rules="[rules.required]"
                            item-text="value"
                            autocomplete="off"
                            item-value="key"
                    ></v-select>
                    <v-select
                            v-model="value.zone"
                            :label="$t('zone')"
                            :items="zoneOptions"
                            :rules="[rules.required]"
                            item-text="value"
                            autocomplete="off"
                            item-value="key"
                    ></v-select>
                    <UserSelect
                        v-if="value.zone == 'private'"
                        v-model="value.user_id"
                        :label="$t('user')"
                        placeholder="نام و نام خانوادگی  یا شماره همراه"
                        className="ml-2"
                    ></UserSelect>
                    <v-autocomplete
                            v-model="value.fax_channel_id"
                            :items="faxChannels"
                            autocomplete="off"
                            item-text="name"
                            item-value="id"
                            :loading="fetchingFaxChannels"
                            :label="$t('fax_channel')"
                            :rules="[rules.required]"
                    ></v-autocomplete>
                    <v-select
                            v-model="value.state"
                            :label="$t('fax_number_state')"
                            :items="stateOptions"
                            :rules="[rules.required]"
                            item-text="value"
                            item-value="key"
                    ></v-select>

                    <v-checkbox
                            v-model="value.incoming"
                            :label="$t('incoming')"
                            type="checkbox"
                    ></v-checkbox>

                    <v-checkbox
                            v-model="value.outgoing"
                            :label="$t('outgoing')"
                            type="checkbox"
                    ></v-checkbox>
                </v-card-text>

                <v-card-actions class="px-4 pb-4">
                    <v-spacer></v-spacer>

                    <v-btn
                            color="secondary"
                            text
                            class="px-4"
                            @click="$emit('close')"
                    >{{$t('cancel')}}</v-btn>

                    <v-btn
                            color="primary"
                            class="px-4"
                            type="submit"
                    >
                        {{$t('submit')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
    import { mapState,mapActions, mapGetters } from 'vuex';

    import { required} from '../scripts/validationRules';
    import Service from "../services/FaxNumbersService";
    import { priceToTomanPhrase } from '@/scripts/PriceUtils';
    import UserSelect from './UserSelect.vue';

    export default {
        props: {
            item : {
                required: true
            }
        },
        components : {
            UserSelect
        },
        computed : {
            ...mapGetters({
                fetchingUsers: 'users/fetching',
                fetchingFaxChannels: 'faxChannels/fetching',
                activeUsers: 'users/activeUsers',
            }),
            ...mapState({
                faxChannels: state => state.faxChannels.items
            }),
            stateOptions(){
                return Object.keys(this.$t("fax_number_state_options")).map(key => {
                    return {
                        key,
                        value: this.$t("fax_number_state_options")[key]
                    }
                });
            },
            zoneOptions(){
                return Object.keys(this.$t("zone_options")).map(key => {
                    return {
                        key,
                        value: this.$t("zone_options")[key]
                    }
                });
            },
            gradeOptions(){
                return Object.keys(this.$t("grade_options")).map(key => {
                    return {
                        key,
                        value: this.$t("grade_options")[key]
                    }
                });
            },

        },
        data() {
            return {
                validForm: false,
                loading: 0,
                value : {...this.item},
                rules: {
                    required
                },

            }
        },
        created(){
            if(this.activeUsers.length <= 0){
                this.syncUsers();
            }

            if(this.faxChannels.length <= 0){
                this.syncFaxChannels();
            }
        },
        methods: {
            priceToTomanPhrase,
            ...mapActions({
                syncUsers: 'users/fetchUsers',
                syncFaxChannels: 'faxChannels/sync'
            }),

            async submit() {
                if(!this.validForm) {
                    return this.$refs.form.validate();
                }

                try {
                    this.loading++;

                    let {
                        data
                    } = this.value.id ? await Service.update(this.value) : await Service.create(this.value);
                    this.$emit('submit', data);

                    this.$notify({
                        group: 'formGroup',
                        type: 'success',
                        title: data.message,
                    });

                } finally {
                    this.loading--;
                }

                this.$emit('close');
            }
        }
    }
</script>